import { createAsyncThunk } from "@reduxjs/toolkit";
import { dummySubscriptions } from "../../data/dummySubscriptionData";
import { api } from "../../config/api";

export const getAllSubscriptions = createAsyncThunk(
  "subscriptions/getAllSubscriptions",
   async ({ ...queryParams }) => {
      const response = await api.get("/subscriptions/all-payments", {
        params: queryParams,
      });
      console.log("response", response);
      return response.data;
    }
);

export const getPaymentSummary = createAsyncThunk(
  "subscriptions/getPaymentSummary",
  async () => {
    const response = await api.get("/subscriptions/summary");
    console.log("response", response);
    return response.data;
  }
);

export const createSubscriptionAdjustment = createAsyncThunk(
  "subscriptions/createSubscriptionAdjustment",
  async (payload) => {
    const response = await api.post("/admin/subscription-adjustment", payload);
    console.log("createAdjustment response", response);
    return response.data;
  }
);


